<template>
  <v-autocomplete
    clearable
    :disabled="loading"
    :items="authorList"
    :loading="loading"
    v-bind="attributes"
    v-on="listeners"
  />

</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    isMultiple: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      default: null
    },
    isDense: {
      type: Boolean,
      required: false
    },
    isChips: {
      type: Boolean,
      required: true
    },
    componentLabel: {
      type: String,
      default: 'Author Object'
    },
  },
  data () {
    return {
      loading: false,
      errorString: this.errorMessage
    }
  },
  watch: {
    loading (value) {
      this.$emit('loadingState', value)
    }
  },
  computed: {
    ...mapState({
      recordList: state => state.author.list,
    }),
    authorList () {
      let list = []
      this.recordList.forEach((value) => {
        list.push({
          text: this.displayName(value) ,
          value: value.id
        })
      })
      return list
    },
    attributes () {
      return {
        label: this.componentLabel,
        multiple: this.isMultiple,
        outlined: true,
        dense: this.isDense,
        chips: this.isChips,
        'error-messages': this.errorString,
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    ...mapActions({
      getList: 'author/getList',
    }),
    async getLeagues () {
      try {

        this.loading = true
        this.errorString = null

        await this.getList({ per_page: 'all' })


      } catch (err) {
        console.log(err)
        this.errorString = 'Unable to retrieve data.'
      } finally {
        this.loading = false
      }
    },

    displayName(data) {
      let firstName = data.first_name || ''
      let lastName = data.last_name || ''

      let displayName = firstName + ' ' + lastName

      return displayName
    }
  },

  mounted () {
    this.getLeagues()
  },
}
</script>
